import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CalculateSubscriptionOptions } from '../../../../../../common/src/options/calculate-subscription.options';
import { FinalizeSubscriptionOptions } from '../../../../../../common/src/options/finalize-subscription.options';
import { SubscriptionInfoResponse } from '../../../../../../common/dist/angular/responses/subscription-info.response';
import { map } from 'rxjs/operators';
import { StripePaymentMethodModel } from '../../../../../../common/dist/angular/models/stripe-payment-method.model';
import { StripeInvoiceModel } from '../../../../../../common/dist/angular/models/stripe-invoice.model';
import { EnvironmentManager } from '../../../../modules/src/lib/core/managers/environment.manager';
import { BaseApiController } from './base.api-controller';

@Injectable()
export class BillingApiController extends BaseApiController {
  constructor(
    private readonly httpClient: HttpClient,
    environmentManager: EnvironmentManager,
  ) {
    super(environmentManager);
  }

  public async setupSubscription(idempotencyKey: string): Promise<{ client_secret: string }> {
    return this.httpClient.post<{
      client_secret: string
    }>(`${this.getApiUrl()}/api/billing/subscriptions/setup`, {}, {
      headers: {
        'idempotency-key': idempotencyKey,
      },
    }).toPromise();
  }

  public async calculateSubscription(calculateSubscriptionOptions: CalculateSubscriptionOptions): Promise<SubscriptionInfoResponse> {
    return this.httpClient.post<SubscriptionInfoResponse>(`${this.getApiUrl()}/api/billing/subscriptions/calculate`, calculateSubscriptionOptions)
      .pipe(map(
        subscriptionInfo => {
          return {
            ...subscriptionInfo,
            freeTrialEndsAt: new Date(subscriptionInfo.freeTrialEndsAt),
          };
        })).toPromise();
  }

  public async finalizeSubscription(finalizeSubscriptionOptions: FinalizeSubscriptionOptions, idempotencyKey: string): Promise<void> {
    return this.httpClient.post<void>(`${this.getApiUrl()}/api/billing/subscriptions/finalize`, finalizeSubscriptionOptions, {
      headers: {
        'idempotency-key': idempotencyKey,
      },
    }).toPromise();
  }

  public async getPaymentMethods(): Promise<StripePaymentMethodModel[]> {
    return this.httpClient.get<StripePaymentMethodModel[]>(`${this.getApiUrl()}/api/billing/payment-methods`).toPromise();
  }

  public async getInvoices(): Promise<StripeInvoiceModel[]> {
    return this.httpClient.get<StripeInvoiceModel[]>(`${this.getApiUrl()}/api/billing/invoices`).toPromise();
  }

  public async deletePaymentMethod(id: string): Promise<void> {
    return this.httpClient.delete<void>(`${this.getApiUrl()}/api/billing/payment-methods/${id}`).toPromise();
  }
}
